import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { useDispatch } from "react-redux";
import { ReOrderContent } from "../../Redux/Actions/ExploreAction";

//nested data is ok, see accessorKeys in ColumnDef below

const CustomTable = (props) => {
  //should be memoized or stable
  const [rows, setRows] = useState([]);
  const {
    data,
    columns,
    loading,
    totalRecords,
    pagination,
    onPaginationChange,
    onGlobalFilterChange,
    globalFilter,
  } = props;
  useEffect(() => {
    setRows(data);
  }, [data]);
  const dispatch = useDispatch();
  return (
    <MaterialReactTable
      columns={columns}
      data={rows}
      enableRowOrdering
      state={{ showSkeletons: loading, pagination, globalFilter }}
      rowCount={totalRecords}
      manualPagination
      manualFiltering
      onPaginationChange={onPaginationChange}
      onGlobalFilterChange={onGlobalFilterChange}
      positionGlobalFilter="left"
      enableColumnFilters={false}
      muiTableBodyRowDragHandleProps={({ table }) => ({
        onDragEnd: () => {
          const { draggingRow, hoveredRow } = table.getState();
          //called api for dragging rows
          const payload = {
            startIndex: draggingRow.original.order_no,
            endIndex: hoveredRow.original.order_no,
            category: draggingRow.original.category.id
          }          
          dispatch(ReOrderContent(payload)); //called api for re-order          
        },
      })}
    />
  );
};

export default CustomTable;
